import { OverallStatus } from '../../../../enums/DeliveryEnum';
import { t } from '../../../../i18n';

/**
 * 将订单池 overall_status 数值映射为国际化文案（与 enum.overallStatus.* 一致）。
 */
export function getOverallStatusLabelByCode(code: number | null | undefined): string {
  if (code == null) return '-';
  const key = (Object.keys(OverallStatus) as (keyof typeof OverallStatus)[]).find(
    (k) => typeof OverallStatus[k] === 'number' && OverallStatus[k] === code
  );
  if (!key) {
    return String(code);
  }
  return t(`enum.overallStatus.${String(key)}`, { defaultValue: String(code) });
}

/** DateTimeRangeFilterItem 产出的本地时间串 → GraphQL LocalDateTime 可解析的 ISO 片段 */
export function toIsoLocalDateTimeForApi(localYmdHms: string): string {
  return localYmdHms.trim().replace(' ', 'T');
}
